var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{ active: _vm.isActivated },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.taskConfig.gameIconUrl}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.taskConfig.gameName))])])}
var staticRenderFns = []

export { render, staticRenderFns }